import React, { useContext } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import MyContext from "../MyContext/MyContext";

const FeatureOne = () => {
  const { data } = useContext(MyContext);

  function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
      <button
        type="button"
        onClick={onClick}
        className={`${className} slick-next slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
      >
        <i className="ph ph-caret-right" />
      </button>
    );
  }

  function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
      <button
        type="button"
        onClick={onClick}
        className={`${className} slick-prev slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1`}
      >
        <i className="ph ph-caret-left" />
      </button>
    );
  }

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 5,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      { breakpoint: 1399, settings: { slidesToShow: 4 } },
      { breakpoint: 992, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 575, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="feature" id="featureSection">
      <div className="container container-lg">
        <div className="position-relative arrow-center">
          <div className="feature-item-wrapper">
            <Slider {...settings}>
              {data.map((cat) => (
                <div key={cat.id} className="feature-item text-center">
                  <div className="feature-item__thumb rounded-circle overflow-hidden">
                    <Link
                      to={`/shop/${cat.routing_category}`}
                      className="w-100 h-100 flex-center"
                    >
                      <img
                        src={cat.category_img}
                        alt={cat.category}
                        className="object-cover w-full h-full"
                      />
                    </Link>
                  </div>
                  <div className="feature-item__content mt-16">
                    <h6 className="text-lg mb-8">
                      <Link
                        to={`/shop/${cat.routing_category}`}
                        className="text-inherit"
                      >
                        {cat.category}
                      </Link>
                    </h6>
                    <span className="text-sm text-gray-400">
                      {cat.products?.length || 0}+ Products
                    </span>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureOne;
